import gql from "graphql-tag";

export const LOAD_AUDIT_FOR_GRAPH = gql`
  query auditService_findByFilter($params: FindByFilterParamsInput) {
    auditService_findByFilter(params: $params) {
      results { index auditableEntity date newValue oldValue }
    }
  }`
